// extracted by mini-css-extract-plugin
module.exports = {"service":"service-module--service--QAJjL","icon":"service-module--icon--3NNCj"};